export class LocationDetailsSession {
    countryKey: string;
    postal: string;
    state: string;
    city: string;
    address1: string;
    address2: string;
    address3: string;
    clientKey: string;
    nickname: string;
    comesFromURL: boolean;
    companyName: string;
}